import { useState, useEffect } from "react";
import { scroller, Element } from "react-scroll";
import { step1Items } from "./utils";
import RightArrow from "@/public/icons/hiw-right-arrow.svg";
import TimeClock from "@/public/icons/clock-orange-circle.svg";
import Step1Image from "@/public/icons/hiw-step1.svg";
import ExpandableBox from "@/components/landing-old/ExpandableBox";

const Step1 = ({
  openFaqIndex,
  setOpenFaqIndex,
}: {
  openFaqIndex?: number;
  setOpenFaqIndex?: React.Dispatch<React.SetStateAction<number | undefined>>;
}): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(-1);

  useEffect(() => {
    if (openFaqIndex !== undefined) setActiveIndex(openFaqIndex);
  }, [openFaqIndex]);

  const clickHandler = (idx: number) => {
    setOpenFaqIndex?.((current) => (current === idx ? -1 : idx));
    setActiveIndex((current) => (current === idx ? -1 : idx));
  };

  const scrollToCalculator = () => {
    scroller.scrollTo("calculator", { smooth: true, duration: 500, offset: -180 });
  };

  return (
    <section className="relative bg-white w-full px-4 md:px-5 lg:px-20 lg:py-16">
      <div className="h-20 lg:h-0"></div>
      <h2 className="text-landing-orange font-bold text-2xl lg:text-3xl mb-3 lg:mb-5">Step 1</h2>
      <div className="flex flex-col lg:flex-row items-center lg:items-start">
        <div className="flex flex-col lg:w-1/2">
          <h3 className="text-4xl lg:text-5xl font-bold text-landing-blue mb-5 md:mb-3 lg:mb-5">
            Get your budget
          </h3>
          <div className="flex flex-col md:flex-row lg:flex-col items-center">
            <div className="w-full md:w-1/2 lg:w-full">
              <h4 className="font-serif text-xl lg:text-3xl text-landing-blue mb-5">
                Use our calculator to see what could you afford.
              </h4>
              <p className="font-base mb-5">
                It takes 10 seconds. Just enter your annual income, including anyone else you plan
                to move in with, and we’ll tell you the maximum monthly rental amount and home buy
                back price.
              </p>
            </div>
            <div className="w-full md:w-1/2 lg:w-full hidden md:flex lg:hidden md:ml-5 justify-around">
              <Step1Image width={"90%"} height={"100%"} />
            </div>
          </div>
          <div className="flex flex-row justify-between mb-0 md:mb-6 lg:mb-9">
            <button onClick={scrollToCalculator} className="relative flex items-center">
              <span className="hidden md:inline-block relative text-base font-bold text-landing-orange">
                Calculate your monthly cost
              </span>
              <span className="inline-block md:hidden relative text-base font-bold text-landing-orange">
                Get your budget
              </span>
              <RightArrow className="md:ml-3 ml-1" />
            </button>
            <div className="flex flex-row justify-between items-center">
              <TimeClock className="mr-3" />
              <span className={`inline-block relative text-base text-landing-orange`}>
                10 seconds
              </span>
            </div>
          </div>

          <div className="md:hidden w-full my-5 flex justify-around">
            <Step1Image width={"80%"} height={"100%"} />
          </div>
          <div className="relative z-30 w-full">
            {step1Items.map((faq, idx) => (
              <Element key={idx} name={`step1-faq-${idx}`}>
                <ExpandableBox
                  question={faq.question}
                  answer={faq.answer}
                  active={activeIndex === idx}
                  clickHandler={() => clickHandler(idx)}
                  page={"hiw"}
                />
              </Element>
            ))}
          </div>
        </div>
        <div className="hidden lg:flex lg:justify-around lg:w-1/2 ml-5">
          <Step1Image width={"80%"} height={"100%"} />
        </div>
      </div>
    </section>
  );
};

export default Step1;
